import React, { useEffect } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import Card from "../../../components/Card";
import Skeleton from "react-loading-skeleton";
import BarChart from "../../../components/BarChart";
import { FaClock } from "react-icons/fa";
import { selectCancelledCertificateCount, selectIssuedCertificateCount, selectPendingCertificateCount, selectVerifiedCertificateCount, STATUS } from "../../../redux/features/dashboard/dashboardSlice";
import { getAllCancelledCount, getAllIssuedCount, getAllPendingCount, getAllVerifiedCount } from "../../../redux/features/dashboard/dashboardService";
import { MdVerified } from "react-icons/md";
import { PiCertificateFill } from "react-icons/pi";
import { TbCertificateOff } from "react-icons/tb";

const Dashboard = () => {

  const dispatch = useDispatch();

  const { status, data } = useSelector(selectPendingCertificateCount);
  const { status: verifiedStatus, data: verifiedCount } = useSelector(selectVerifiedCertificateCount);
  const { status: issuedStatus, data: issuedCount } = useSelector(selectIssuedCertificateCount);
  const { status: cancelledStatus, data: cancelledCount } = useSelector(selectCancelledCertificateCount);

  useEffect(() => {
    dispatch(getAllPendingCount({}));
    dispatch(getAllVerifiedCount({}));
    dispatch(getAllIssuedCount({}));
    dispatch(getAllCancelledCount({}));
  }, [dispatch]);

  return (
    <div>
      <div className={styles.cardContainer}>
        <div className={styles.topCardContainer}>
          <Card icon={<FaClock size={30} />} text='Pending' number={status === STATUS.LOADING ? <Skeleton /> : data?.count || 0} />
        </div>
        <div className={styles.middleCardContainer}>
          <Card icon={<MdVerified size={30} />} text='Verified' number={verifiedStatus === STATUS.LOADING ? <Skeleton /> : verifiedCount?.count || 0} />
        </div>
        <div className={styles.bottomCardContainer}>
          <Card icon={<PiCertificateFill size={30} />} text='Issued' number={issuedStatus === STATUS.LOADING ? <Skeleton /> : issuedCount?.count || 0} />
        </div>
        <div className={styles.fourthCardContainer}>
          <Card icon={<TbCertificateOff size={30} />} text='Cancelled' number={cancelledStatus === STATUS.LOADING ? <Skeleton /> : cancelledCount?.count || 0} />
        </div>
      </div>
      <div className={styles.graphContainer}>
        <div className={styles.barChartContainer}>
          <BarChart
            chartTitle='Certificate Creation'
          />
        </div>
        <div className={styles.lineChartContainer}>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
